import type { IndicatorName, IndicatorSettings, AcceleratorOscillatorSettings, ADXSettings, AlligatorSettings, AroonSettings, BollingerBandsSettings, DonchianChannelSettings, FractalSettings, FractalChaosBandsSettings, IchimokuKinkoHyoSettings, MACDSettings, OsMASettings, ParabolicSARSettings, RSISettings, StochasticOscillatorSettings, SuperTrendSettings, ZigZagSettings } from "../../model";
import { INDICATOR_DEFAULT_SETTINGS } from "../../model";

export const getInputSummary = (name: IndicatorName, settings?: IndicatorSettings): string => {
  const s = settings ?? INDICATOR_DEFAULT_SETTINGS[name];
  if (!s) return "";
  switch (name) {
    case "acceleratorOscillator": {
      const ao = s as AcceleratorOscillatorSettings;
      return `${ao.aoShortPeriod} ${ao.aoLongPeriod} ${ao.acSmaPeriod}`;
    }
    case "aDX": {
      const adx = s as ADXSettings;
      return `${adx.adxSmoothing} ${adx.diLength}`;
    }
    case "donchianChannel": {
      const dc = s as DonchianChannelSettings;
      return `${dc.period}`;
    }
    case "bollingerBands": {
      const bb = s as BollingerBandsSettings;
      return `${bb.period} ${bb.deviation}`;
    }
    case "aroon": {
      const ar = s as AroonSettings;
      return `${ar.period}`;
    }
    case "alligator": {
      const al = s as AlligatorSettings;
      return `${al.jawsPeriod} ${al.teethPeriod} ${al.lipsPeriod}`;
    }
    case "fractal": {
      const fr = s as FractalSettings;
      return `${fr.period}`;
    }
    case "fractalChaosBands": {
      const fcb = s as FractalChaosBandsSettings;
      return `${fcb.period}`;
    }
    case "ichimokuKinkoHyo": {
      const ich = s as IchimokuKinkoHyoSettings;
      return `${ich.tenkanSenPeriod} ${ich.kijunSenPeriod} ${ich.senkouSpanBPeriod}`;
    }
    case "mACD": {
      const macd = s as MACDSettings;
      return `${macd.fastPeriod} ${macd.slowPeriod} ${macd.signalPeriod}`;
    }
    case "osMA": {
      const osma = s as OsMASettings;
      return `${osma.fastEmaPeriod} ${osma.slowEmaPeriod} ${osma.signalSmaPeriod}`;
    }
    case "parabolicSAR": {
      const sar = s as ParabolicSARSettings;
      return `${sar.acceleration} ${sar.maxAcceleration}`;
    }
    case "superTrend": {
      const st = s as SuperTrendSettings;
      return `${st.atrPeriod} ${st.multiplier}`;
    }
    case "zigZag": {
      const zz = s as ZigZagSettings;
      return `${zz.deviation} ${zz.depth} ${zz.backstep}`;
    }
    case "rSI": {
      const rsi = s as RSISettings;
      return `${rsi.period}`;
    }
    case "stochasticOscillator": {
      const st = s as StochasticOscillatorSettings;
      return `${st.kPeriod} ${st.dPeriod} ${st.smoothingPeriod}`;
    }
    default:
      return "";
  }
};
